import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Greeting band at the top of the student / tutor dashboards (replaces the old breadcrumb bar).
export default function DashHeader({ role }) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.authReducer);
  const isTutor = role === "teacher";
  const firstName = (user?.name || "").trim().split(/\s+/)[0];

  return (
    <div className="dash-header">
      <div className="container">
        <div className="dash-header-inner">
          <div>
            <span className="dash-eyebrow">
              <span className="dash-eyebrow-dot" /> {isTutor ? t("dashHome.tutor_eyebrow") : t("dashHome.student_eyebrow")}
            </span>
            <h1 className="dash-greeting">
              {firstName ? t("dashHome.welcome", { name: firstName }) : t("dashHome.welcome_fallback")}
            </h1>
            <p className="dash-subtitle">{isTutor ? t("dashHome.tutor_subtitle") : t("dashHome.student_subtitle")}</p>
          </div>
          <Link to={isTutor ? "/dashboard/my-course/create" : "/all-courses"} className="dash-header-btn">
            <i className={isTutor ? "fa-light fa-plus" : "fa-light fa-magnifying-glass"} />
            {isTutor ? t("dashHome.create_course") : t("dashHome.browse_courses")}
          </Link>
        </div>
      </div>
    </div>
  );
}
